import { css } from '@emotion/core'

export default ({
  theme: {
    colors,
    typography,
    components: { productPrice }
  },
  isFetching
}) => css`
  /*  hide the slots until the products are loaded  */
  .slot {
    opacity: ${isFetching ? '0' : '1'};
  }
`
